import { ImpactArgs, NotifyArgs, VibrateArgs } from './types';

export const hapticImpact = (args: ImpactArgs = {}) => {
  // eslint-disable-next-line no-console
  console.debug(`Haptic ${args.style} impact triggered`);
};

export const hapticNotification = (args: NotifyArgs) => {
  // eslint-disable-next-line no-console
  console.debug(`Haptic ${args.type} notification triggered`);
};

export const vibrate = (args: VibrateArgs) => {
  if (!('vibrate' in navigator)) {
    return;
  }

  navigator.vibrate(args.duration);
};
